import PropTypes from 'prop-types';
import optionListPropTypes from './optionListPropTypes';

const genericBlockPropTypes = {
  clientUuid: PropTypes.string.isRequired,
  id: PropTypes.string,
  type: PropTypes.string,
  logic: PropTypes.object,
  page: PropTypes.number,
  options: optionListPropTypes,
  plainText: PropTypes.string,
  required: PropTypes.bool,
  commentsEnabled: PropTypes.bool,
  commentsLabel: PropTypes.string,
};

// @TODO reuse this PropTypes across all question components @sinslav
export default genericBlockPropTypes;
